import { createAnatomy as o } from "../../anatomy/dist/index.mjs";
import { createScope as i } from "../../dom-query/dist/index.mjs";
import { createProps as r } from "../../types/dist/index.mjs";
var a = o("switch").parts("root", "label", "control", "thumb");
a.build();
var t = i({
  getRootId: (e) => {
    var d;
    return ((d = e.ids) == null ? void 0 : d.root) ?? `switch:${e.id}`;
  },
  getLabelId: (e) => {
    var d;
    return ((d = e.ids) == null ? void 0 : d.label) ?? `switch:${e.id}:label`;
  },
  getThumbId: (e) => {
    var d;
    return ((d = e.ids) == null ? void 0 : d.thumb) ?? `switch:${e.id}:thumb`;
  },
  getControlId: (e) => {
    var d;
    return ((d = e.ids) == null ? void 0 : d.control) ?? `switch:${e.id}:control`;
  },
  getHiddenInputId: (e) => {
    var d;
    return ((d = e.ids) == null ? void 0 : d.hiddenInput) ?? `switch:${e.id}:input`;
  },
  getRootEl: (e) => t.getById(e, t.getRootId(e)),
  getHiddenInputEl: (e) => t.getById(e, t.getHiddenInputId(e))
});
r()([
  "checked",
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "invalid",
  "label",
  "name",
  "onCheckedChange",
  "readOnly",
  "required",
  "value"
]);
export {
  a as anatomy
};
